module.exports = __webpack_public_path__ + "036b75125821b56a34578d058124440b.svg";